import { useEffect, useState } from "react";
import { _Entailment } from "../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { BasicTable } from "../../../theme/Component/BasicTable";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { Modal } from "../../../theme/Component/Modal";
import { Singleton } from '../../../../core/services/Singleton';
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { toast } from "react-toastify";
import { AppointmentManualEditor } from "../AppointmentManual/AppointmentManual.editor";
import { AppointmentGroupManualEditor } from "../AppointmentGroupManual/AppointmentGroupManual.editor";
import { _SIIFTCON6Valuetwo } from "../../../../core/services/dataBean/EntityCatalogVdos";
import { SiifAuxiliaryCatalogSelect } from "../../../admin/configuracion/SIIFAuxiliaryCatalog/SiifAuxiliaryCatalogSelect";
import { SIIFTCON17Select } from "../../../admin/configuracion/SIIFTCON17/SIIFTCON17Select";
import { SelectAccountantTree } from "../../../contabilidad/catalogo-cuentas/AccountantTree/SelectAccountantTree";
import usePaginator from "../../../theme/Component/usePaginator";
import { BasicButton } from "../../../theme/Component/BasicButton";
import { SelectRecurso } from "../../../Factoty&Production/LabourType/SelectRecurso";
import { SIIFTCON17Editor } from "../../../admin/configuracion/SIIFTCON17/SIIFTCON17Editor";
import { SIIFAuxiliaryTypeSelect } from "../../../admin/configuracion/SIIFAuxiliaryType/SIIFAuxiliaryTypeSelect";


export const SIIFTCON6Value = () => {

    const siif = useDataBean(_SIIFTCON6Valuetwo);
    const single = Singleton.getInstance();
    const paginador = usePaginator();
    const [lista, setLista] = useState<any>([]);
    const [SiifAux, setSiifAux] = useState<number>(null)
    const [Siif17, setSiif17] = useState<any>({
        name: null,
        ID: null
    })
    const [AccountantIDCode, setAccountantIDCode] = useState<any>(null)
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [paginador.page])

    const getLista = () => {

        siif.instance.getSIIFTCON6ValueCatalog(SiifAux, Siif17.ID, AccountantIDCode, paginador.page, 15).then(
            (resp: any) => {
                if (resp) {
                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * (15));
                    paginador.setRegiPerPage(15)
                    setLista(resp.List)
                }
            }
        )

    }

    const create = () => {
        siif.setBean({

        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        siif.deleteItemVoid(siif.bean.IDSIIFTCON6Value).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "view": false });
            }
        )

    }
    const editaItem = () => {
        if (!siif.bean.AccountantIDStr) {
            toast.warning("Debe seleccionar una Cuenta Contable.");
            return;
        }
        //console.log(entailment.bean);
        siif.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'ID', property: 'IDSIIFTCON6Value', visible: true },
        { title: 'Auxiliar', property: 'SIIFAuxiliaryName', visible: true },
        { title: 'TCON17', property: 'SIIFTCON17ValueName', visible: true },
        { title: 'Cuenta Contable', property: 'AccountantIDName', visible: true },

    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "name": `Editar ${siif.bean.Name}`, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <BasicPage titulo="Auxiliares TCon6">
            <div className="row">
                <div className="col-md-4">
                    <SiifAuxiliaryCatalogSelect idSelector={SiifAux} onChange={(e) => setSiifAux(e)} />
                    {/* <SIIFAuxiliaryTypeSelect idSelector={SiifAux} onChange={(e) => setSiifAux(e)} /> */}
                </div>
                <div className="col-md-4">
                    <SIIFTCON17Editor render={Siif17.Name} idSelector={Siif17.ID} onChange={(e) => { setSiif17({ ...Siif17, "ID": e.IDSIIFTCON17Value, "Name": e.Description }) }} returnType="Object" />
                    {/* <SIIFTCON17Select idSelector={Siif17} onChange={(e) => setSiif17(e)} /> */}
                </div>
                <div className="col-md-4">
                    <SelectAccountantTree label="Cuenta Contable" jsonCode={AccountantIDCode} onChange={(e) => setAccountantIDCode(e.JsonCode)} />
                </div>
                <div className="col-md-4">
                    <BasicButton icon="ri-align-justify" eventClick={getLista}>Buscar</BasicButton>
                </div>
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={siif.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem} pageTop={paginador.page} next={paginador.next} back={paginador.back} records={paginador} customRows={15}></BasicTable>
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <div className="row">
                            <div className="col-md-6">

                                <SiifAuxiliaryCatalogSelect idSelector={siif.bean.IDSIIFAuxiliary} onChange={(e) => siif.setBean({ ...siif.bean, "IDSIIFAuxiliary": e })} />
                            </div>
                            <div className="col-md-6">
                                <SIIFTCON17Editor render={siif.bean.SIIFTCON17ValueName} idSelector={siif.bean.IDSIIFTCON17Value} onChange={(e) => { siif.setBean({ ...siif.bean, "ID": e.IDSIIFTCON17Value, "SIIFTCON17ValueName": e.Description }) }} returnType="Object" />
                            </div>
                            <div className="col-md-6">
                                <SelectAccountantTree label="Cuenta Contable" jsonCode={siif.bean.AccountantIDStr} onChange={(e) => siif.setBean({ ...siif.bean, "AccountantIDStr": e.JsonCode })} />
                            </div>
                            <div className="col-md-6">
                                <label>Valor TCON6</label>
                                <input type="text" name="TCon6Value" className="form-control" value={siif.bean.TCon6Value} onChange={(e) => siif.setBean({ ...siif.bean, "TCon6Value": e.target.value })} />
                            </div>
                        </div>
                    </Modal>
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item {siif.bean.Name}</strong>
                    </ModalConfirm>
                </div>
            </div>
        </BasicPage>
    )
}